import { unByKey } from 'ol/Observable';
import { getDistance } from 'ol/sphere';
import { distance } from 'ol/coordinate'
import Overlay from 'ol/Overlay';
import { toLonLat } from 'ol/proj';
import { Circle, LineString } from 'ol/geom'
import { DEFAULT_GEOMETRY_EXPORT } from '../../../plugins/utils/features/EditableFeature';
import { MEASURE } from '../../../plugins/utils/styles/styles';
import { round, azimuth, center } from '../../../plugins/utils/helpers';
import { LIGHT_CONDITION, NAUTICAL_MILE_IN_METERS } from '../../../plugins/utils/constantes';
import EditFeatureLayer from '../../../plugins/utils/modules/EditableFeatureLayer';
import { getGUIColor, GREEN_COLOR } from '../../../plugins/utils/GuiColor';

export const SWINGING_AREA_GEOMETRY_TRANSFORMER =  {
  geometry: (geom) => {
    if (geom instanceof LineString) {
      const coords = geom.getCoordinates()
      const centerCoord = center(coords[0], coords[1])
      const radius = distance(centerCoord, coords[0])
      geom = new Circle(centerCoord, radius)
    }
    return DEFAULT_GEOMETRY_EXPORT.geometry(geom)
  },
  editInstruction: (geom) => {
    if (geom instanceof LineString) {
      const coords = geom.getCoordinates()
      return `l[${coords.map((coord) => toLonLat(coord).join())}]`
    }
  }
}

export default class MeasureLayerManager extends EditFeatureLayer {
  constructor(map) {
    const lightCondition = localStorage.getItem('layerColor') || LIGHT_CONDITION.DAY;
    const greenColor = getGUIColor(GREEN_COLOR, lightCondition);
    const greenMeasureStyle = MEASURE(greenColor);

    super(map, { style: greenMeasureStyle, drawStyle: greenMeasureStyle, stopClick: true });

    this.map_ = map;
    this.sketch_ = undefined;
    this.listener_ = undefined;
    this.measureTooltip_ = undefined;
    this.measureTooltipArray_ = [];
    this.featureEditionLayer_.setVertexInsertionOnEdit(false);
  }

  onDrawStart_(e) {
    unByKey(this.listener_);
    this.featureEditionLayer_.clear();
    this.sketch_ = e.feature;
    let tooltipCoord = e.coordinate;
    this.clearMeasureTooltips_();
    const measureTooltipElement = document.createElement('div');
    measureTooltipElement.className = 'tooltip tooltip-measure';
    this.measureTooltip_ = new Overlay({
      stopEvent: false,
      element: measureTooltipElement,
      offset: [0, -7],
      positioning: 'bottom-center',
    });
    this.map_.addOverlay(this.measureTooltip_);
    this.measureTooltipArray_.push(this.measureTooltip_);

    this.listener_ = this.sketch_.getGeometry().on('change', (evt) => {
      const geom = evt.target;
      if (geom.getCoordinates().length > 2) {
        this.featureEditionLayer_.finishDrawing();
      }
      const output = formatMeasureElement(geom);
      this.measureTooltip_.getElement().innerHTML = output;
      const coords = geom.getCoordinates();
      tooltipCoord = center(coords[coords.length - 2], coords[coords.length - 1]);
      this.measureTooltip_.setPosition(tooltipCoord);
    });

    function formatMeasureElement(line) {
      const coords = line.getCoordinates();
      const secondToLast = toLonLat(coords[coords.length - 2]);
      const last = toLonLat(coords[coords.length - 1]);

      let distance = getDistance(secondToLast, last);
      const nmFrac = NAUTICAL_MILE_IN_METERS / 10;

      const measureUnit = localStorage.getItem('measureUnit');
      if (!measureUnit || measureUnit === 'null' || measureUnit === 'nautical') {
        distance = distance > nmFrac ? `${round(distance / NAUTICAL_MILE_IN_METERS, 2)} NM` : `${round(distance, 2)} m`;
      } else {
        distance = distance > 1000 ? `${round(distance / 1000, 2)} km` : `${round(distance, 2)} m`;
      }
      let azimuth_ = azimuth(secondToLast, last);
      azimuth_ = round(azimuth_, 0);

      return `Distance: ${distance}<br/>Azimuth: ${azimuth_}°`;
    }
  }

  onDrawEnd_(e) {
    for (const tooltip of this.measureTooltipArray_) {
      tooltip.getElement().className = 'tooltip tooltip-static';
    }
    super.onDrawEnd_(e);
  }

  clearMeasureTooltips_() {
    for (const tooltip of this.measureTooltipArray_) {
      this.map_.removeOverlay(tooltip);
    }
    this.measureTooltipArray_ = [];
  }

  clear() {
    super.clear();
    this.clearMeasureTooltips_();
  }

  setLightCondition(lightCondition) {
    const green = getGUIColor(GREEN_COLOR, lightCondition);
    this.featureEditionLayer_.setStyle(MEASURE(green));
  }

  getFeatureForSave(isSwing = false) {
    // let geom = this.getGeometry();
    // if (isSwing && geom instanceof LineString) {
    //   const coords = geom.getCoordinates()
    //   const centerCoord = center(coords[0], coords[1])
    //   const radius = distance(centerCoord, coords[0])
    //   geom = new Circle(centerCoord, radius)
    // }    
    // if (geom instanceof Circle) geom = fromCircle(geom, NUMBER_POINT_CIRCLE_TO_POLYGON)
    // const coords = geom.getCoordinates()
    // const secondToLast = toLonLat(coords[coords.length - 2]);
    // const last = toLonLat(coords[coords.length - 1]);
    // const ls = lineString([secondToLast, last], { featureType: 'Quotation' })
    // return ls
  }
}